export default __webpack_public_path__ + "static/media/2.e48fcf6d.jpg";